import { useRef, useState , useEffect, Fragment } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";

import back from "../../back.png";
import InputDownloader from "../../helpers/InputDownloader";
import MediaLink from "../../helpers/MediaLink";


function Thread(props)
{

    const [row,setRow] = useState(props.row) ;
    const [tab,setTab] = useState(null) ;

    const onBack = (e) => {
        props.goBack();
    }



       const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_msg,history_msg', {
            method: 'POST', 
            body: JSON.stringify({
                id: props.row.id,
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                                
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    if(tab == null)
    {
        setTab([]);
        getTab();
        
    }


    return <div className="view_content">

                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>


                <h1><PlTitle userData={props.userData} /> /  {row.tytul}</h1>


                <div className="bg_center">
                    
                        <div className="x_review_chat">
                                
                                {
                                    tab != null &&
                                    <Fragment>
                                            {
                                                tab.map((item, ix) => {

                                                    return <div className="x_review_item">
                                                            <div className="x_kto">{item.nadawca.nazwa}, {item.czas}: </div>
                                                            <div className="x_tresc">{item.tresc}: </div>
                                                        </div>

                                                })
                                            }
                                    </Fragment>
                                }

                             

                        </div>

                </div>

    </div>
}



export default Thread;